(function () {
  'use strict';

  function initVSBlog(section) {

    if (!section) return;

    if (section.dataset.vsBlogReady === 'true') {
      return;
    }

    section.dataset.vsBlogReady = 'true';

    const cards = section.querySelectorAll('.vs-blog-card');

    cards.forEach(function (card) {

      card.addEventListener('mouseenter', function () {
        card.classList.add('vs-blog-card--hover');
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('vs-blog-card--hover');
      });

    });

  }


  function initAllVSBlogs() {

    document
      .querySelectorAll('[data-vs-blog]')
      .forEach(function (section) {
        initVSBlog(section);
      });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllVSBlogs
    );

  } else {

    initAllVSBlogs();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector('[data-vs-blog]');

      if (section) {
        initVSBlog(section);
      }

    }
  );

})();